// Scoped roles may only open their page. Direct page loads are redirected
// server-side (server/middleware/auth.ts); this covers client-side navigation.
export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.server) return
  if (to.path === '/login' || to.path.startsWith('/auth/')) return

  const { user, fetchUser, isIntegrationsViewer } = useUser()
  if (!user.value) {
    try {
      await fetchUser()
    } catch {
      return
    }
  }

  if (isIntegrationsViewer.value) {
    if (to.path === '/integrations') return
    return navigateTo('/integrations', { replace: true })
  }
})
